import { styled } from "styled-components";

const Container = styled.div`
  body { margin: 20px; }
  h1, h2, h3 { margin: 2rem 0; }
  h1 { font-size: 24px; }
  h2 { font-size: 20px; }
  h3 { font-size: 18px; }
  p, li { margin: 5px 0; }
  ul { margin: 10px 0 10px 20px; }
`;

export function ServiceTerms() {
  return (
    <Container>
      <h2>제1조 (목적 등)</h2>
      <p>1. FOCUS View 서비스 약관(이하 "본 약관")은 이용자가 포커스에이치엔에스 주식회사(이하 "FOCUS AI")에서 제공하는 모바일 앱 관련 서비스(이하 "서비스")를 이용함에 있어 이용자와 FOCUS AI의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>
      <p>2. 이용자가 되고자 하는 사람은 FOCUS AI가 정한 회원약관에 동의를 확인하는 페이지에서 "회원약관에 동의"를 선택한 경우에만 회원가입정보를 입력하는 페이지로 화면이 이동할 수 있으며, “개인정보 처리에 관한 동의” 및 "회원약관에 동의"를 선택한 후 "다음단계"를 누르면 본 약관에 동의하는 것으로 간주합니다.</p>

      <h2>제2조 (이용자의 정의)</h2>
      <p>"이용자"란 FOCUS View에 접속하여 본 약관에 따라 FOCUS AI 회원으로 가입하여 FOCUS AI가 제공하는 서비스를 받는 자를 말하며, 계약당사자인 고객에 국한되지 아니 합니다.</p>

      <h2>제3조 (회원 가입)</h2>
      <p>1. 이용자가 되고자 하는 사람은 FOCUS AI가 정한 가입 양식에 따라 FOCUS AI가 제공하는 각종 서비스를 받기 위한 회원정보를 기입하고 "가입하기" 버튼을 누르는 방법으로 회원가입 신청 및 가입이 이루어지며, 회원가입 시 제1조에 따라 FOCUS AI의 회원정보 수집·이용에 동의 후 이용이 가능합니다.</p>

      <h2>제4조 (서비스의 제공 및 변경)</h2>
      <p>1. FOCUS AI는 이용자에게 FOCUS AI가 자체 개발하거나 다른 회사와의 협력계약 등을 통해 회원들에게 제공할 모바일 앱 관련 서비스를 제공합니다.</p>

      <h2>제5조 (서비스의 중단)</h2>
      <p>1. FOCUS AI는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등 불가항력의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</p>

      <h2>제6조 (회원 탈퇴 및 자격 상실 등)</h2>
      <p>1. 이용자는 FOCUS AI에 언제든지 자신의 회원 등록을 말소해 줄 것을 요청할 수 있으며 FOCUS AI는 위 요청을 받은 즉시 해당 이용자의 회원 등록 말소를 위한 절차를 밟습니다.</p>

      <h2>제7조 (이용자에 대한 통지)</h2>
      <p>1. FOCUS AI가 특정 이용자에 대한 통지를 하는 경우 이용자가 회원가입 시 FOCUS AI에게 제공한 메일주소로 할 수 있습니다.</p>

      <h2>제8조 (이용자의 개인정보보호)</h2>
      <p>FOCUS AI는 관련법령이 정하는 바에 따라서 회원등록 정보를 포함한 이용자의 개인정보를 보호하기 위하여 노력합니다. 이용자의 개인정보 보호에 관해서는 개인정보보호법 및 관련법규와 FOCUS AI가 정하는 "개인정보보호정책"에서 정한 바에 의합니다.</p>

      <h2>제9조 (FOCUS AI의 의무)</h2>
      <p>1. FOCUS AI는 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 본 약관이 정하는 바에 따라 지속적이고 안정적으로 서비스를 제공하기 위해서 노력합니다.</p>

      <h2>제10조 (이용자의 ID 및 비밀번호에 대한 의무)</h2>
      <p>1. FOCUS AI가 관계법령, "개인정보보호정책"에 의해서 그 책임을 지는 경우를 제외하고, 자신의 ID와 비밀번호에 관한 관리책임은 각 이용자에게 있습니다.</p>

      <h2>제11조 (이용자의 의무)</h2>
      <p>1. 이용자는 다음 각 호의 행위를 하여서는 아니 됩니다.</p>
      <ul>
        <li>회원가입신청 또는 변경 시 허위내용을 등록하는 행위</li>
        <li>FOCUS AI에 게시된 정보를 게시자 또는 회사의 승인 없이 변경하는 행위</li>
        <li>FOCUS AI 기타 제3자의 명예, 인격권 또는 지적재산권을 침해하거나 업무를 방해하는 행위</li>
      </ul>

      <h2>제12조 (공개게시물의 삭제)</h2>
      <p>FOCUS AI는 이용자의 공개게시물의 내용이 다음 각 호에 해당하는 경우 사전 통지 없이 해당 게시물을 삭제 또는 등록을 거부할 수 있습니다.</p>

      <h2>제13조 (저작권의 귀속 및 이용제한)</h2>
      <p>1. FOCUS AI가 작성한 저작물에 대한 저작권 기타 지적재산권은 FOCUS AI에 귀속합니다.</p>

      <h2>제14조 (약관의 개정)</h2>
      <p>1. FOCUS AI는 관련법을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</p>

      <h2>제15조 (재판관할)</h2>
      <p>FOCUS AI와 이용자 간의 분쟁으로 인한 소송은 민사소송법상의 관할권이 있는 대한민국 법원에 제기하기로 합니다.</p>

      <h2>부칙</h2>
      <p>본 약관은 2025. 04. 01 일자로부터 적용하고, 종전의 약관은 본 약관으로 대체합니다.</p>
    </Container>
  )
}